import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { Bell } from 'lucide-react';

function getSeverityDot(severity) {
  if (severity === 'Critical') return 'bg-[hsl(0,84%,60%)]';
  if (severity === 'Warning') return 'bg-[hsl(24,94%,56%)]';
  if (severity === 'High') return 'bg-[hsl(24,94%,56%)]';
  if (severity === 'Medium') return 'bg-[hsl(45,93%,58%)]';
  if (severity === 'Info') return 'bg-[hsl(45,93%,58%)]';
  return 'bg-[hsl(264,92%,70%)]';
}

export function RecentActivity({ activity = [] }) {
  return (
    <Card className="bg-card border-border/80" data-testid="recent-activity-card">
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2">
          <Bell className="w-4 h-4 text-[hsl(264,92%,70%)]" />
          <CardTitle className="text-base font-semibold">Recent Account Activity</CardTitle>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-xs text-muted-foreground -mt-1 mb-2">Latest alerts and metric events for this account.</p>
        {activity.length === 0 && <p className="text-sm text-muted-foreground">No recent activity</p>}
        {activity.map((item, i) => {
          const time = item.timestamp ? new Date(item.timestamp) : null;
          const timeAgo = time ? getTimeAgo(time) : '';
          return (
            <div key={i} className="flex items-start gap-3">
              <span className={cn('w-3 h-3 rounded-full mt-0.5 flex-shrink-0', getSeverityDot(item.severity))} />
              <div className="min-w-0">
                <p className="text-sm leading-tight">{item.description}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{timeAgo}</p>
              </div>
            </div>
          );
        })}
        <Link to="/history" className="text-xs text-[hsl(188,100%,55%)] hover:underline inline-block">
          View History
        </Link>
      </CardContent>
    </Card>
  );
}

function getTimeAgo(date) {
  const now = new Date();
  const diff = Math.floor((now - date) / 1000);
  if (diff < 3600) return `${Math.max(1, Math.floor(diff / 60))} min ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} hour${Math.floor(diff / 3600) > 1 ? 's' : ''} ago`;
  return `${Math.floor(diff / 86400)} day${Math.floor(diff / 86400) > 1 ? 's' : ''} ago`;
}
